export default __webpack_public_path__ + "fonts/ABBvoice_W_Lt-XD3z3.eot";